import { CSSProperties } from 'react';

import extensions from './extensions.json';
import icons from './icons';
import { Extension } from './types';

interface Props {
    name: string;
    className?: string;
    style?: CSSProperties;
}

/*
 * This component shows the icon of a file, according to its extension.
 */

const getIcon = (filename: string) => {
    const extension = '.' + filename.split('.').pop()?.toLowerCase() ?? '';
    const unknown = extensions[''];
    return (extensions[extension as keyof typeof extensions] || unknown);
};

const FileIcon = (props: Props) => {
    const { name, ...otherProps } = props;

    const extension = getIcon(name);

    const firstChar = extension.charAt(0);
    const finalExtension = (firstChar >= '0' && firstChar <= '9') ? ('_' + extension) : extension;

    return (
        <img src={icons[finalExtension as Extension]} alt={extension} {...otherProps} />
    );
};

export default FileIcon;
